<template>
  <button
    v-on="$listeners"
    v-bind="$attrs"
    class="app-button--icon"
    :class="[effect, hasEffect]"
    data-jest="app-button--icon"
  >
    <Icon v-if="icon" :icon="icon" />
    <slot />
  </button>
</template>

<script>
// Components
import Icon from 'Ui/AppIcon'

export default {
  name: 'AppButtonIcon',

  components: {
    Icon,
  },

  props: {
    icon: {
      type: String,
      default: 'far fa-times',
    },

    effect: {
      type: String,
      default: '',
    },
  },

  computed: {
    hasEffect() {
      return this.effect && 'effect'
    },
  },
}
</script>

<style scoped>
.app-button--icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  color: var(--c-secondary);
  border-radius: 50%;
  transition: var(--transition--default);
}

.app-button--icon i {
  line-height: 0;
  pointer-events: none;
  transform-origin: center;
}

.effect.app-button--icon i {
  transition: var(--transition--default);
}

/* button effects */
.app-button--icon.rotate:hover i {
  transform: rotate(180deg);
}
</style>
